module.exports = __webpack_public_path__ + "img/image-3.d53ba5e7.jpeg";